import { gql } from '@apollo/client';

export const GET_TIPS = gql`
  query GetTips($input: TipListInput!) {
    getTips(input: $input) {
      entities {
        __typename
        id
        message
        amount
        profit
        createdAt
        paidAt
        orderStatus
        type
        imageURL
        payment {
          __typename
          type
        }
        paymentMethod {
          id
          type
        }
        customer {
          __typename
          id
          firstName
          lastName
          slug
          storeDetails {
            avatarURL
          }
        }
        ... on StreamTipEntity {
          __typename
          streamId
          stream {
            __typename
            id
            name
            store {
              firstName
              lastName
              storeDetails {
                id
                avatarURL
              }
            }
          }
        }
        ... on UserTip {
          __typename
          recipient {
            __typename
            id
            firstName
            lastName
            slug
            storeDetails {
              id
              avatarURL
            }
          }
        }
      }
      total
      offset
      limit
    }
  }
`;

export const GET_TIPS_RECEIVED = gql`
  query GetTipsReceived($input: TipListInput!) {
    getTipsReceived(input: $input) {
      entities {
        __typename
        id
        message
        amount
        profit
        createdAt
        paidAt
        orderStatus
        imageURL
        type
        payment {
          __typename
          type
        }
        paymentMethod {
          id
          type
        }
        customer {
          __typename
          id
          firstName
          lastName
          slug
          storeDetails {
            avatarURL
          }
        }
        ... on StreamTipEntity {
          __typename
          streamId
          stream {
            __typename
            id
            name
            store {
              firstName
              lastName
              storeDetails {
                id
                avatarURL
              }
            }
          }
        }
        ... on UserTip {
          __typename
          recipient {
            __typename
            id
            firstName
            lastName
            slug
            storeDetails {
              id
              avatarURL
            }
          }
        }
      }
      total
      offset
      limit
    }
  }
`;

export const GET_TIP_IMAGE_STATE = gql`
  query GetTipImageState($input: GetTipImageStateInput!) {
    getTipImageState(input: $input) {
      id
      imageStatus
    }
  }
`;

export const GET_TIP = gql`
  query TipById($input: GetTipType!) {
    tipById(input: $input) {
      id
      imageURL
    }
  }
`;

export const GET_TIP_DETAILS = gql`
  query GetTipDetails($input: GetTipType!) {
    tipById(input: $input) {
      id
      message
      amount
      profit
      createdAt
      paidAt
      orderStatus
      type
      imageURL
      customer {
        id
        firstName
        lastName
        slug
        storeDetails {
          id
          avatarURL
        }
      }
      ... on StreamTipEntity {
        stream {
          id
          name
          store {
            id
            firstName
            lastName
            storeDetails {
              id
              storeName
              avatarURL
            }
          }
        }
      }
      ... on UserTip {
        recipient {
          id
          firstName
          lastName
          slug
          storeDetails {
            id
            storeName
            avatarURL
          }
        }
      }
    }
  }
`;

export const GET_TIP_MESSAGE_PRESETS = gql`
  query GetTipMessagePresets {
    getTipMessagePresets {
      id
      text
      isActive
    }
  }
`;
